import { EdenDateOrDateTime } from "src/eden/content";
import * as Event from "src/state/modules/event";
import { getBrowserTimezone } from "src/utils/date-utils";
import { mapFromLocation } from "./location";

export type APIEventAndPregameData = {
  event: any;
  pregame_data: any;
};

export const mapApiEvent = (
  { event, pregame_data }: APIEventAndPregameData,
  recurranceRule?: string
): Omit<Event.Event, "teamID" | "rsvps"> => {
  let opponentTeam: Event.Opponent | undefined;

  if (pregame_data && pregame_data.opponent_name !== null) {
    opponentTeam = {
      id: pregame_data.opponent_id === null ? undefined : pregame_data.opponent_id,
      name: pregame_data.opponent_name || "TBD",
      shouldImportOpponent: false,
    };
  }
  let homeAway: Event.HomeAwayOption | undefined;
  if (pregame_data && pregame_data.home_away !== null) {
    homeAway = pregame_data.home_away;
  }

  const getDateTime = (dateOrDateTime: EdenDateOrDateTime): string => {
    if ("datetime" in dateOrDateTime && dateOrDateTime.datetime != null) return dateOrDateTime.datetime;
    if ("date" in dateOrDateTime) return dateOrDateTime.date;
    throw new Error("Invalid date format");
  };

  const locationWithAddress = mapFromLocation(event.location);

  return {
    id: Event.toEventID(event.id),
    eventType: event.event_type,
    subType: event.sub_type as Event.ScheduledEventSubType[],
    addressParts: locationWithAddress.addressParts,
    location: locationWithAddress.location ?? {},
    status: event.status,
    notes: event.notes || undefined,
    title: event.title || undefined,
    seriesID: event.series_id || undefined,
    isFullDay: event.full_day,
    start: getDateTime(event.start),
    end: getDateTime(event.end),
    arrive: event.arrive ? event.arrive.datetime : undefined,
    timezone: event.timezone || getBrowserTimezone(),
    recurranceRule,
    opponentTeam,
    homeAway,
    lineupID: pregame_data?.lineup_id ? Event.toLineupID(pregame_data?.lineup_id) : undefined,
  };
};
